export type LikertValue = 'Very_Low' | 'Low' | 'Medium' | 'High' | 'Very_High';

export interface LikertOption {
  value: string;
  label: string;
}

export interface SecurityQuestionDefinition {
  key: string;
  title: string;
}

export interface SecuritySectionDefinition {
  key: string;
  title: string;
  introKey?: string;
  questions: SecurityQuestionDefinition[];
}

export interface SecurityFormDefinition {
  key: string;
  title: string;
  formType: string;
  sections: SecuritySectionDefinition[];
}

export type PhysicalFieldType =
  | 'radio'
  | 'input'
  | 'phone'
  | 'textarea'
  | 'multicheckbox'
  | 'repeat'
  | 'address';

export interface PhysicalFieldOption {
  value: string;
  label: string;
}

export interface PhysicalFieldDefinition {
  key: string;
  type: PhysicalFieldType;
  label: string;
  description?: string;
  required: boolean;
  hideExpression?: string;
  options?: PhysicalFieldOption[];
}

export interface PhysicalSectionDefinition {
  key: string;
  title: string;
  fields: PhysicalFieldDefinition[];
}

export interface PhysicalSecurityFormDefinition {
  key: string;
  title: string;
  formType: string;
  sections: PhysicalSectionDefinition[];
}

export interface SecurityQuestionMeta {
  key: string;
  prompt: string;
  options: LikertOption[];
  thingsToConsider: Partial<Record<LikertValue, string>>;
  moreInfo?: SecurityInfoSection[];
}

export type SecurityQuestionMetaMap = Record<string, SecurityQuestionMeta>;
export type SecurityIntroInstructionMap = Record<string, string>;

export interface SecurityInfoItem {
  text?: string;
  link?: string;
}

export interface SecurityInfoBodyBlock {
  items: SecurityInfoItem[];
  separator?: string;
}

export interface SecurityInfoSection {
  title: string;
  body: SecurityInfoBodyBlock[];
}

export const LIKERT_OPTIONS: LikertOption[] = [
  { value: 'Very_Low', label: 'Very Low' },
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
  { value: 'High', label: 'High' },
  { value: 'Very_High', label: 'Very High' }
];

export function toQuestionTitle(key: string): string {
  return key
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
